const company_config = {
    // GENERAL INFO
    company_name:"KAHRABA",
    name : {
        arabic: 'كهرباء',
        english: 'KAHRABA',
    },
    description: {
        arabic: `شركة كهرباء هي شركة متخصصة في حلول الطاقة، تعمل في مجالات توليد وتوزيع الكهرباء.
        وتُعد واحدة من أكبر وأبرز الشركات في القطاع الخاص المصري، حيث بنت سمعة قوية كمطور رائد لحلول الطاقة، وخاصة في مجالات التوليد والتوزيع، والطاقة المتجددة، وكشركة مقاولات EPC.
        
        كما حصلت كهرباء على رخصة الفئة (A) من هيئة تنظيم الكهرباء (ERA) لتوليد الطاقة.
        وحصلت أيضًا على رخصة توزيع وبيع الكهرباء من الهيئة نفسها لتغطية مختلف أنحاء مصر.
        وتحمل كهرباء رخصة مقاول فئة (A) كمقاول EPC لمحطات المحولات من الاتحاد المصري لمقاولي التشييد والبناء.
        كما حصلت على رخصة من هيئة الطاقة الجديدة والمتجددة (NREA) لتنفيذ مشروعات محطات الطاقة الشمسية الكهروضوئية EPC.
        
        ووقّعت كهرباء اتفاقية مع الشركة المصرية لنقل الكهرباء (EETC) تمنح الشركة حقوق الربط والاستخدام لشبكة الكهرباء القومية.`,
        
        english: `KAHRABA is a power solutions company specializing in energy generation and distribution. It is recognized as one of the largest and most respected players in Egypt’s private sector.  The company has established a strong reputation as a leading developer of power solutions, particularly in power generation and distribution, renewable energy, and as an EPC contractor. KAHRABA has also obtained a license Class A from (ERA) to generate power.
        obtained a Class A license from (ERA) to distribute and sell electricity across Egypt. 
        KAHRABA holds a Class A EPC Contractor License for power substations from the Egyptian Federation for Construction and Building Contractors.
        KAHRABA has received a license from (NREA) for the EPC of solar PV power plants.
        KAHRABA has reached an agreement with (EETC), granting the company connection and utilization rights to the National Electricity Grid.`,
   
    },
    logo_path : {
        arabic: 'KAHRABA/logo/logo-ar.png',
        english: 'KAHRABA/logo/logo-en.png',
        footer_arabic: 'KAHRABA/logo/logo-ar.png',
        footer_english: 'KAHRABA/logo/logo-en.png',
        dark_logo_ar:'KAHRABA/logo/dark-logo.png',
        dark_logo_en:'KAHRABA/logo/dark-logo.png',
    },
    customer_service_numbers : [
        '01288884411',
    ],
    customer_service_emails : [
        'customer_service@kahraba.com.eg',
    ],
    socialmedia: [
        // {
        //     type: 'facebook',
        //     url: 'https://facebook.com/profile.php?id=61557605083462',
        //     name: 'Midar'
        // },
        // {
        //     type: 'instagram',
        //     url: 'https://www.instagram.com/MIDAR.eg/',
        //     name: 'midar.eg'
        // },
        // {
        //     type: 'twitter',
        //     url: 'https://twitter.com/Mostakbal_city',
        //     name: '@Mostakbal_City'
        // },
        {
            type: 'LinkedIn',
            url: 'https://www.linkedin.com/company/kahraba/',
            name: 'KAHRABA'
        },
        {
            type: 'email',
            url: 'customer_service@kahraba.com.eg',
            name: 'customer_service@kahraba.com.eg'
        },
        // {
        //     type: 'youtube',
        //     url: 'https://www.youtube.com/@MIDAReg',
        //     name: 'MIDAR'
        // },
        
    ],
    
    showLocationDetails:true,
    locations: {
        ar:['18 شارع حسن الرزاز',' العجوزة, الجيزة, مصر' ],
        en:["18 Hassan Al Razaz st", 'Agouza, Giza, Egypt']
    },
    location_map:"KAHRABA Company",
    location_map_link:"https://maps.google.com/maps/search/National%20Electricity%20Technology%20Company/@30.233768463134766,31.776121139526367,17z?hl=en",  
    colors: [
        '#e94c28',
        '#002751',
        '#2870b9'
    ],
    PortalLangs:{
        firstLang:'ع',
        secondLang:'En'
    },
    defaultLang:1,
    currency_en:'EGP',
    currency_ar:'جنيه مصري',
    // LOGIN PAGE
    unAuth_request:false,
    login_faq:false,
    aboutus:true,
    fastRecharge:false,
    fastRecharge_elements:{
        unit_code:false, // changed to account_reference
        account_reference: true,
        meter_code:true,
        phone_number:false,
        amount:true,
        meter_placeholder_ar:"مثال 123456",
        meter_placeholder_en:"e.g. 123456",
        unit_placeholder_ar:"", // changed to account_reference_placeholder_ar
        unit_placeholder_en:"", // changed to account_reference_placeholder_en
        account_reference_placeholder_ar:"مثال EARKGSB13100",
        account_reference_placeholder_en:"e.g. EARKGSB13100",
        phone_number_placeholder_en:"e.g 01234567890",
        phone_number_placeholder_ar:"مثال 01234567890",
    },
    fastRechargeLimit:{
        min:100,
        max:50000,
    },

    first_login_pass_msg_en:"",
    first_login_pass_msg_ar:"",
    
    forgot_pass:true,

    login_footer:true,
    login_footer_elements:{
        numbers:true,
        email:true,
        location:true,
        headQuarters:true,
    },

    
    // NAVBAR
    requests:false,
    faq:false,
    notifications:false,
    raise_complaint_inquiry:false,
    guide:false,
    // FOOTER
    mobile_app:false,
    mobile_app_QRs:{
        ios:'https://apps.apple.com/eg/app/midar/id6466739593',
        android:'https://play.google.com/store/apps/details?id=com.pylon.customers.mc',
    },
    footer_back_img_path:'',

    // about us
    about_paragrh:{
        ar:`الرؤية (Vision):

        أن نكون المزود الرائد لحلول الطاقة المبتكرة والمستدامة.
        
        الرسالة (Mission):
        
        نقدّم حلول طاقة مبتكرة ومستدامة لضمان توليد وتوزيع كهرباء موثوقة وبتكلفة فعّالة في جميع أنحاء مصر والشرق الأوسط وأفريقيا.
        خدماتنا مُصمَّمة خصيصاً لتلبية احتياجات عملائنا على مدار الساعة (24/7)، مع الالتزام بتجاوز المعايير البيئية وضمان بيئة عمل آمنة لفريقنا.
        
        القيم (Values):
        
        1. حلول متكاملة من البداية إلى النهاية (End-to-End Solutions):
        التصميم → التمويل → التنفيذ → التشغيل → الصيانة.
        
        2. الاستدامة والابتكار (Sustainability & Innovation):
        قيادة دمج الطاقة المتجددة والتوسّع في استخدام الطاقة الشمسية من أجل منظومة طاقة نظيفة وجاهزة للمستقبل.
        
        3. بدون تكلفة استثمار مبدئية على العملاء (Zero Upfront CAPEX):
        من خلال نماذج BOOT (البناء – التملّك – التشغيل – نقل الملكية) وPPA (اتفاقية شراء الطاقة).
        
        4. خبرة من الفئة الأولى في EPC (EPC Class A Expertise):
        تميز مثبت في الهندسة والتوريد والإنشاء لمحطات توليد الطاقة ومحطات المحولات الكهربائية عالية السعة.
        
        5. شراكات موثوقة (Trusted Partnerships):
        نخدم القطاعات الصناعية والزراعية وقطاعات البنية التحتية بأعلى درجات الموثوقية والشفافية والتميّز الفني.`, 
        en:`vision:To Be The Leading Provider of Innovative and Sustainable Energy Solutions.
        Mission:We provide innovative and sustainable energy solutions for reliable, cost-effective electricity generation and distribution across Egypt, the Middle East, and Africa. 
        Our services are customized to meet client needs 24/7, exceeding environmental standards and ensuring a safe work environment for our team.
        Values:End-to-End Solutions:  Design → Finance → Build → Operate → Maintenance.
        Sustainability & Innovation: Driving renewable energy integration and solar power adoption for a cleaner, future-ready energy ecosystem.
        Zero Upfront CAPEX for clients through BOOT (Build–Own–Operate–Transfer) and PPA (Power Purchase Agreement) frameworks.
        EPC Class A Expertise: Proven excellence in engineering, procurement, and construction for high-capacity power substations and generation power plants.
        Trusted Partnerships: Powering industrial, agricultural, and infrastructure clients with reliability, transparency, and technical excellence.`,
    },
    about_img_src:'',
    // HOME PAGE

    // meter section 
    remaining_credit:true,
    last_update_date_time:true,
    consumption_chart:true,
    recharge_from_home:true,
  
    // payment histroy section 
    payment_history_table:true,
    payment_receipt_history_table:true,

    //consumption section
    consumption_history_table:true,
 
    // recharging
    paytabs:false,
    nbe:true,
    nbeVersion:"100",
    response_type:'json',
    enter_total_recahrge_due:false,
    allow_recharge_without_pay_all:false,
    force_pay_all:true,
    show_due_payments:true,
    fees_precentage:0,
    fixed_fees:0,
    failure_Recharge_msg_ar:"فشلت بسبب فشل الإتصال بالعداد. الرجاء الاتصال بدعم العملاء على ",
    failure_Recharge_msg_en:"failed due to a failure in communication with the meter. Please contact the customer support on ",
    Invoice_img:'National_Bank_of_Egypt_Logo.png',
    
    // guide page
      show_elec_params_table:true,
    // PROFILE

    // personal info
    changePass:true,
    addEmailToContactInfoMsg:true,

    // notification
    show_critical_part:false,
    notfication_settings:false,
    numberOfLoginFooterElements:4,
    notfication_settings_elements:{
     sms:true,
     mobile_app:true,
     customer_portal:true,
     email:true
    },
    
       
}

export default  {company_config}
